import axios, { AxiosResponse } from 'axios';
import { MergeResult, RedBookRecord } from '../domain/domain';
import { getHeaders, BASE_URL } from './common';

export function getRedBook(billNo: string = "", billSection: string = "") : Promise<AxiosResponse<RedBookRecord[]>> {
    if (!billSection) {
        return axios.get(BASE_URL + `/legal/redbook?bill_no=${billNo}`, {headers: getHeaders()});
    }
    return axios.get(BASE_URL + `/legal/redbook?bill_no=${billNo}&bill_section=${billSection}`, {headers: getHeaders()});
}

export function mergeRedBook(billNo: string = "", billSection: string = "", redBookRecords: RedBookRecord[]): Promise<AxiosResponse<MergeResult>> {
    return axios.post(BASE_URL + `/legal/redbook/merge`, redBookRecords, { headers: getHeaders() });
}